import React, { useRef, useState } from 'react';
import styled from 'styled-components/macro';
import { useOnClickOutside } from '../../../../../helpers/hooks/useOnClickOutside';
import { colourNeutral02, colourNeutral10 } from '../../../../../styling/colours';
import { fontFamily, fontSize02, fontSize04 } from '../../../../../styling/fonts';
import { shadow2 } from '../../../../../styling/shadows';
import { spacing02, spacing03, spacing04 } from '../../../../../styling/spacing';
import { IconButton } from '../../DeleteAndDuplicateButtons';
import { ReactComponent as ArrowDownward } from '../../../../../images/icons/arrow-downward.svg';
import { RoomFormModel } from '../../rooms/roomFormModel';

type Props = {
  fillDownRoomFields: (fieldName: keyof RoomFormModel) => void;
};

export const FillDownRoomsButton = ({ fillDownRoomFields }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useOnClickOutside(menuRef, () => setIsOpen(false));

  return (
    <Container>
      <IconButton onClick={() => setIsOpen(true)}>
        <ArrowDownward />
      </IconButton>
      {isOpen && (
        <Menu ref={menuRef}>
          <MenuButtonItem type="button" onClick={() => fillDownRoomFields('floorLevelCode')}>
            Fill Room Levels
          </MenuButtonItem>
          <MenuButtonItem type="button" onClick={() => fillDownRoomFields('floorConstruction')}>
            Fill Room Floor Constructions
          </MenuButtonItem>
          <MenuButtonItem type="button" onClick={() => fillDownRoomFields('thermostatTypeCode')}>
            Fill Room Thermostats
          </MenuButtonItem>
        </Menu>
      )}
    </Container>
  );
};

const Container = styled.div`
  display: inline-block;
  position: relative;
`;

const Menu = styled.div`
  box-shadow: ${shadow2};
  position: absolute;
  background-color: white;
  width: 250px;
  left: 55px;
  top: 0px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  z-index: 10;
`;

export const MenuButtonItem = styled.button`
  font-family: ${fontFamily};
  font-size: ${fontSize02};
  outline: none;
  border: none;
  background-color: transparent;
  text-align: left;
  color: ${colourNeutral02};
  padding: ${spacing03} ${spacing04};
  transition: all 0.25s ease;
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  &:hover,
  &:focus {
    background-color: ${colourNeutral10};
  }

  svg {
    height: ${fontSize04};
    width: ${fontSize04};
    min-width: ${fontSize04};
    margin-right: ${spacing02};
  }
`;
